import { Table, TableBody, TableCell, TableHead, TableRow, Grid, Paper } from '@mui/material';
import { makeStyles } from '@mui/styles';
import Button from '../../UI/Button';
import { dateFormat } from '../../../util/DateUtil';
import Loading from '../../UI/Loading';

const useStyles = makeStyles({
    container: {
        padding: '10px',
    },
});

const DiaLetivoExtraTable = ({ listDiaLetivoExtra, setDiaLetivoExtra, isLoading }) => {
    const classes = useStyles();
    return (
        <Grid
            container
            component={Paper}
            className={classes.container}
        >
            <Button
                onClick={() => setDiaLetivoExtra({
                    eNovo: true
                })}
            >
                Novo Dia Letivo Extra
            </Button>
            {isLoading ?
                <Grid
                    container
                    justifyContent='center'
                >
                    <Loading description="Carregando Dias não Letivo" />
                </Grid>
                :
                <Table size="small" aria-label="a dense table">
                    <TableHead>
                        <TableRow>
                            <TableCell>Data</TableCell>
                            <TableCell>Descrição</TableCell>
                            <TableCell>Ações</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {listDiaLetivoExtra.map((diaLetivoExtra) => (
                            <TableRow key={diaLetivoExtra.codigo}>
                                <TableCell>{dateFormat(diaLetivoExtra.data)}</TableCell>
                                <TableCell>{diaLetivoExtra.descricao}</TableCell>
                                <TableCell>
                                    <Button
                                        onClick={() => setDiaLetivoExtra(diaLetivoExtra)}
                                    >
                                        Selecionar
                                    </Button>
                                </TableCell>

                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            }

        </Grid>
    )
}

export default DiaLetivoExtraTable;